<template>
  <div>
    <div
      id="main-loader"
      class="wrapper"
    >
      <img
        src="@/assets/loader.gif"
        alt="Loading..."
      >
      <h3>Loading...</h3>
    </div>
    <div
      id="main-loader-api"
      class="wrapper"
    >
      <img
        src="@/assets/loader.gif"
        alt="Loading..."
      >
      <h3>Loading...</h3>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Loader'
}
</script>

<style scoped lang="scss">
.wrapper {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1999;
  background-color: #ffffff;
  margin: auto;
  color: #000000;
  display: none;
}

img {
    width: 100px;
    height: 100px;
    margin-top: 100px;
  }

@media (min-width: 992px) {

  img {
    width: 200px;
    height: 200px;
    margin-top: calc(50vh - 180px);
  }
}
</style>
